import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { api, useAgentApi } from '@sib/api';

export type ExternalTokenRequestDto = {
  orgId: string;
};

export type ExternalTokenResponseDto = {
  access_token?: string;
  token_type?: string;
};

export const useExternalTokenAuth = (
  organizationId: string,
  aiPort?: string | null,
  options?: UseMutationOptions<
    ExternalTokenResponseDto,
    Error,
    ExternalTokenRequestDto
  >
) => {
  const agentApi = useAgentApi(aiPort);

  return useMutation({
    ...options,
    mutationFn: async (data: ExternalTokenRequestDto) => {
      const franzToken =
        await api.token.tokenControllerGetFranzOboToken(organizationId);

      const response = await agentApi.instance.get<ExternalTokenResponseDto>(
        '/auth/external-token',
        {
          params: {
            org_id: data.orgId,
          },
          headers: {
            Authorization: `Bearer ${franzToken}`,
          },
          withCredentials: true,
        }
      );

      return response.data;
    },
  });
};
